import React, { useState, useEffect } from "react";
import axios from "axios";
import { ChevronLeft, ChevronRight, ArrowRightLeft } from "lucide-react";

const API = process.env.REACT_APP_API_URL;

const StockTransfer = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const fetchTransfers = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/inventory/activities?type=Transfer&page=${page}&limit=10`);
      setActivities(data.activities || []);
      setTotalPages(data.totalPages || 1);
      setTotalItems(data.total || 0);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransfers();
  }, [page]);

  return (
    <section className="min-h-screen bg-[#f3f3f3] p-4 sm:p-6 font-sans">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-4">
        <h1 className="text-xl md:text-3xl font-philosopher text-primaryTextColor flex items-center gap-2">
          <ArrowRightLeft className="text-purple-600 w-7 h-7" />
          Stock Transfer
        </h1>
        <button className="bg-[#b07d17] hover:bg-[#8c6312] text-white px-4 py-2 rounded-lg flex items-center gap-2 transition shadow-sm text-sm font-medium">
          New Transfer
        </button>
      </div>

      <div className="bg-white border border-[#D5D9D9] rounded-lg shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-[#f2f2f2] border-b border-[#D5D9D9] text-gray-700">
              <tr>
                <th className="px-4 py-3 font-semibold">Date</th>
                <th className="px-4 py-3 font-semibold">Product</th>
                <th className="px-4 py-3 font-semibold">SKU</th>
                <th className="px-4 py-3 font-semibold text-right">Qty Transferred</th>
                <th className="px-4 py-3 font-semibold">From Warehouse</th>
                <th className="px-4 py-3 font-semibold">To Warehouse</th>
                <th className="px-4 py-3 font-semibold">By</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="px-4 py-8 text-center text-gray-500">Loading transfers...</td>
                </tr>
              ) : activities.length > 0 ? (
                activities.map((act) => (
                  <tr key={act._id} className="border-b border-gray-200 hover:bg-gray-50 transition">
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">
                      {new Date(act.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                    </td>
                    <td className="px-4 py-3 text-gray-900 font-medium">
                      {act.productName || act.product?.name?.en || "--"}
                    </td>
                    <td className="px-4 py-3 text-gray-500">{act.sku || act.product?.sku || "--"}</td>
                    <td className="px-4 py-3 font-bold text-gray-900 text-right">{act.quantity}</td>
                    <td className="px-4 py-3 text-gray-600">{act.warehouse || "--"}</td>
                    <td className="px-4 py-3 text-gray-600">{act.warehouseTo || "--"}</td>
                    <td className="px-4 py-3 text-gray-600">{act.performedBy}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="px-4 py-8 text-center text-gray-500">No stock transfers recorded.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {!loading && activities.length > 0 && (
          <div className="px-6 py-4 border-t border-gray-200 flex flex-col md:flex-row items-center justify-between gap-3 bg-white">
            <h6 className="text-sm text-gray-500">
              Showing {activities.length} of {totalItems} entries
            </h6>
            <div className="flex items-center gap-1">
              <button
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                className="p-2 rounded-lg border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => setPage(i + 1)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${page === i + 1
                      ? "bg-blue-500 text-white"
                      : "border border-gray-300 hover:bg-gray-100"
                    }`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
                className="p-2 rounded-lg border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default StockTransfer;
